import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  MenuToggle,
  MobileLink,
  MobileMenu,
  MobileMenuFooter,
  Nav,
  NavInner,
  NavLink,
  NavLogo,
  NavLogoImg,
  NavMenu,
  NavRight,
} from "./NavBarElements";
import { LanguageSwitcher } from "../LanguageSwitcher";
import { useLanguage } from "../../../contexts/LanguageContext";
import { useScrolledPast } from "../../../hooks";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isScrolled = useScrolledPast(24);
  const { pathname } = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = "hidden";
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  const navLinks = [
    {
      to: "/",
      text: t("NAVIGATION.HOME"),
    },
    {
      to: "/products",
      text: t("NAVIGATION.PRODUCTS"),
    },
    {
      to: "/about",
      text: t("NAVIGATION.ABOUT"),
    },
    {
      to: "/contact",
      text: t("NAVIGATION.CONTACT"),
    },
  ];

  return (
    <>
      <Nav $solid={isScrolled || isOpen} $compact={isScrolled}>
        <NavInner>
          <NavLogo to="/" aria-label={t("NAVIGATION.HOME")}>
            <NavLogoImg
              alt={t("HOME.HEADER.TITLE")}
              src={require("../../../assets/images/logos/100x200-white.png")}
            />
          </NavLogo>
          <NavMenu>
            {navLinks.map((link) => (
              <NavLink key={link.to} to={link.to} end={link.to === "/"}>
                {link.text}
              </NavLink>
            ))}
          </NavMenu>
          <NavRight>
            <LanguageSwitcher />
          </NavRight>
          <MenuToggle
            type="button"
            $open={isOpen}
            aria-label={t("NAVIGATION.MENU")}
            aria-expanded={isOpen}
            aria-controls="mobile-menu"
            onClick={() => setIsOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </MenuToggle>
        </NavInner>
      </Nav>
      <MobileMenu id="mobile-menu" $open={isOpen} aria-hidden={!isOpen}>
        {navLinks.map((link, index) => (
          <MobileLink
            key={link.to}
            to={link.to}
            end={link.to === "/"}
            $open={isOpen}
            $index={index}
            tabIndex={isOpen ? 0 : -1}
            onClick={() => setIsOpen(false)}
          >
            {link.text}
          </MobileLink>
        ))}
        <MobileMenuFooter $open={isOpen} $index={navLinks.length}>
          <LanguageSwitcher />
        </MobileMenuFooter>
      </MobileMenu>
    </>
  );
};

export default Navbar;
